module.exports = __webpack_public_path__ + "img/icon-person.c5c412fd.svg";